<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 300px"
          placeholder="姓名、联系方式、证件号"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
        ></el-input>
        <el-radio-group v-model="state.params.status" @change="onLoad">
          <el-radio-button>全部</el-radio-button>
          <el-radio-button :value="1">正常</el-radio-button>
          <el-radio-button :value="0">停用</el-radio-button>
        </el-radio-group>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态/属性">
          <template #default="{ row }">
            <c_tabgroup :value2="row.property == 0 ? '雇员' : '其他'">
              <template #top>
                <text :style="{ color: row.status == 0 ? '#f00' : '#1e90ff' }">
                  {{ row.status == 0 ? "离职" : "在职" }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="姓名/电话">
          <template #default="{ row }">
            <c_tabgroup :value1="row.name" :value2="row.phone" />
          </template>
        </el-table-column>
        <el-table-column label="证件号/性别">
          <template #default="{ row }">
            <c_tabgroup :value1="row.idcard" :value2="row.sex || '-'" />
          </template>
        </el-table-column>
        <el-table-column
          prop="contract_unit_name"
          label="签约单位"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="入/离职时间">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.entry_time"
              :value2="row.resignation_time || '-'"
            />
          </template>
        </el-table-column>
        <el-table-column label="收款信息">
          <template #default="{ row }">
            <div style="display: flex; align-items: center; width: 100%">
              <el-tag
                v-if="row.diff_bank_status != 0"
                effect="dark"
                size="small"
                :type="row.diff_bank_status == 1 ? 'warning' : 'danger'"
                :title="
                  row.diff_bank_status == 1
                    ? '异卡发放审核中'
                    : '异卡审核已驳回'
                "
                style="cursor: pointer; margin-right: 5px"
              >
                {{ row.diff_bank_status == 1 ? "审" : "驳" }}
              </el-tag>
              <div
                style="flex: 1; overflow: hidden"
                v-html="
                  $tab_BuildGroup(row.opening_bank || '-', row.bank_account)
                "
              ></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="扣缴义务人/税局">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.withholding_agent_name"
              :value2="row.tax_bureau_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="View"
              @click="
                state.selectId = row.id;
                state.showDetail = true;
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        @onLoad="
          (pageIndex) => {
            state.params.page = pageIndex;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showDetail"
      title="员工详情"
      @close="state.showDetail = false"
    >
      <c_EmployeeDetail
        @close="
          state.showDetail = false;
          onLoad();
        "
        :id="state.selectId"
      ></c_EmployeeDetail>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { employee_list } from "@/http/api";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_value: "desc",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      employee_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style scoped></style>
